/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  SET_GRUPO_TIPOACTIVIDAD (state, lista) {
    state.grupo_tipo_actividad = lista
  },
  SET_TIPOACTIVIDAD (state, lista) {
    state.tipo_actividad = lista
  },
  SET_TIPOACTIVIDAD_EXTERNA (state, lista) {
    state.tipo_actividad_externa = lista
  },
  SET_SUBPROYECTO (state, lista) {
    state.sub_proyecto = lista
  },
  SET_PROYECTO (state, lista) {
    state.proyecto = lista
  },
  SET_SERVICIO (state, lista) {
    state.servicios = lista
  },
  SET_CRITICALITY (state, lista) {
    state.criticality = lista
  },
  SET_ITILINCIDENTTYPE (state, lista) {
    state.itil_incident_type = lista
  },
  SET_APPLICATIVE (state, lista) {
    state.applicative = lista
  },
  SET_HELP_DESK (state, lista) {
    state.help_desk = lista
  },
  SET_GES_ACTIVOS (state, lista) {
    state.ges_activos = lista
  },
  SET_AREA_BY_RESOURCE (state, lista) {
    state.area_by_resource = lista
  },
  SET_COMPANIES (state, lista) {
    state.companies = lista
  },
  SET_RESOURCE_BY_PROJECT (state, lista) {
    state.resource_by_project = lista
  },
  SET_SERVICE_TYPE_BY_CASE_TYPE (state, lista) {
    state.servicetype_by_casetype = lista
  },
  SET_CRITICALITY_BY_CASE_TYPE (state, lista) {
    state.criticality_by_casetype = lista
  },
  SET_PROJECT_ADD_DATA (state, lista) {
    state.project_add_data = lista
  },
  SET_PROJECTID_ADD_DATA (state, lista) {
    state.projectId_add_data = lista
  },
  SET_SOURCE_REQUEST (state, lista) {
    state.source_request = lista
  },
  SET_REQUEST_CLASS (state, lista) {
    state.request_class = lista
  },
  SET_ACCOUNT_BY_FILTER (state, lista) {
    state.accounts = lista
  },
  SET_TIPOS_CUENTA (state, tiposCuenta) {
    state.tiposCuenta = tiposCuenta
  },
  SET_TIPOS_IDENTIFICACION (state, tiposIdentificacion) {
    state.tiposIdentificacion = tiposIdentificacion
  },
  SET_UNIDAD_NEGOCIO (state, business_unit) {
    state.business_unit = business_unit
  },
}
